import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linebreaks',
})
export class LinebreaksPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    transform(value: any, ...args: any[]): any {
        if (value) {
            // eslint-disable-next-line no-control-regex
            return value.replace(new RegExp('\n', 'g'), '<br />');
        }
        return value;
    }
}
